import React from 'react';
import { useImageModule } from '../hooks/useImageModule';

interface ImageModuleProps {
  id?: number;
  title?: string;
}

const ImageModule: React.FC<ImageModuleProps> = ({ id, title }) => {
  const { data, loading, error } = useImageModule(id, title);

  if (loading) {
    return (
      <section className="image-module-section" style={{ background: '#fff', padding: '0' }}>
        <div style={{ textAlign: 'center' }}>Loading...</div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="image-module-section" style={{ background: '#fff', padding: '0' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center',
          alignItems: 'center',
          height: '515px',
          background: '#f8f9fa',
          color: '#dc3545',
          fontSize: '16px',
          textAlign: 'center',
          padding: '20px'
        }}>
          <div>
            <h3>Error loading image module</h3>
            <p>{error}</p>
            {id && <p>Attempted to load ID: {id}</p>}
          </div>
        </div>
      </section>
    );
  }

  // If no data available (due to 500 error), show a placeholder
  if (!data) {
    return (
      <section className="image-module-section" style={{ background: '#fff', padding: '0' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{
            width: '100%',
            height: '515px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '16px'
          }}>
            Image Module Placeholder
          </div>
        </div>
      </section>
    );
  }

  const { image, altText } = data.data.attributes;
  console.log('Image data in component:', image);
  console.log('Image data structure:', image?.data);
  
  // Handle both possible data structures
  let imageUrl = null;
  if (image?.data?.attributes?.url) {
    // Nested structure: image.data.attributes.url
    imageUrl = image.data.attributes.url;
  } else if (image?.data?.url) {
    // Direct structure: image.data.url
    imageUrl = image.data.url;
  } else if (image?.url) {
    // Flat structure: image.url
    imageUrl = image.url;
  }

  if (!imageUrl) {
    return (
      <section className="image-module-section" style={{ background: '#fff', padding: '0' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{
            width: '100%',
            height: '515px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '16px'
          }}>
            No image uploaded
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="image-module-section" style={{ background: '#fff', padding: '0' }}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <img
          src={imageUrl}
          alt={altText}
          style={{
            width: '100%',
            height: '515px',
            maxWidth: '100%',
            objectFit: 'cover',
          }}
        />
      </div>
    </section>
  );
};

export default ImageModule; 